import isEmpty from './isEmpty'

const isEmptyElement = (el: Element) =>
  isEmpty(el.textContent?.replace(/\s+/g, ''))

export default function normalizeHTML<V extends string | null | undefined>(
  value: V
) {
  if (isEmpty(value)) {
    return value
  }

  const htmlContainer = document.createElement('div')

  htmlContainer.innerHTML = value
    .replace(/&nbsp;+/g, ' ')
    .replace(/\n{2,}/g, '\n')
    .replace(/[ \t\r\f]+/g, ' ')
    .trim()

  let childElIndex = 0
  let childEl = htmlContainer.children[childElIndex]

  while (childEl) {
    const prevChildEl =
      childElIndex > 0 ? htmlContainer.children[childElIndex - 1] : undefined

    const nextChildEl =
      childElIndex < htmlContainer.children.length - 1
        ? htmlContainer.children[childElIndex + 1]
        : undefined

    childEl = htmlContainer.children[childElIndex]

    if (!childEl) {
      break
    }

    childEl.innerHTML = childEl.innerHTML.replace(/(\s*<br>\s*){2,}/g, '<br>')

    while (
      /<br>$/.test(childEl.innerHTML) ||
      /^<br>/.test(childEl.innerHTML) ||
      /&nbsp;$/.test(childEl.innerHTML) ||
      /^&nbsp;/.test(childEl.innerHTML)
    ) {
      childEl.innerHTML = childEl.innerHTML
        .replace(/&nbsp;$/, '')
        .replace(/^&nbsp;/, '')
        .replace(/<br>$/, '')
        .replace(/^<br>/, '')
    }

    const removeChild = () => {
      childEl.remove()
      childElIndex = Math.max(childElIndex - 1, 0)
    }

    if (!prevChildEl && isEmptyElement(childEl)) {
      removeChild()
    } else if (!nextChildEl && isEmptyElement(childEl)) {
      removeChild()
    } else if (
      prevChildEl &&
      isEmptyElement(childEl) &&
      isEmptyElement(prevChildEl)
    ) {
      removeChild()
    } else {
      childElIndex++
    }
  }

  return htmlContainer.innerHTML.trim()
}
